export default function NoMatch() {
  const path = window.location.href;
  const url = path.substring(path.lastIndexOf('/') + 1);
  return <div>{url} 404 - Notfound</div>;
}
